export default __webpack_public_path__ + "9d68fd69581087b8c3aa784644723410.png";